import { IDeleteVerbaPagamentoUseCase } from "../../../presentation/useCases/delete/delete_verba_pagamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteVerbaPagamentoUseCase
 */

export class DeleteVerbaPagamentoUseCase implements IDeleteVerbaPagamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async deleteVerbaPagamento(
    idItemVerba: number,
  ): Promise<void> {
    await this.repository.deleteVerbaPagamento(idItemVerba);
  }
}
